/**
 * Inventory Stock Movement Model
 * Defines movement types, audit reasons, and factory methods
 */

export const MOVEMENT_TYPES = {
  IN: "IN",
  OUT: "OUT",
  ADJUSTMENT: "ADJUSTMENT"
};

export const ADJUSTMENT_REASONS = [
  { id: "Stock Received", label: "📦 Stock Received / Purchase", type: "IN" },
  { id: "Physical Audit", label: "🔍 Physical Audit Correction", type: "ADJUSTMENT" },
  { id: "Damaged", label: "⚠️ Damaged / Defective Stock", type: "OUT" },
  { id: "Customer Return", label: "↩️ Customer Return", type: "IN" },
  { id: "Sample / Promotion", label: "🎁 Sample / Free Issue", type: "OUT" },
  { id: "Sales Invoice", label: "🧾 Sales Invoice Issued", type: "OUT" },
  { id: "Other", label: "📝 Other Reason", type: "ADJUSTMENT" }
];

export function createStockMovement(data = {}) {
  return {
    itemId: data.itemId || "",
    itemName: data.itemName || "",
    itemSku: data.itemSku || "",
    type: data.type || MOVEMENT_TYPES.ADJUSTMENT,
    quantity: Number(data.quantity || 0),
    previousStock: Number(data.previousStock || 0),
    newStock: Number(data.newStock || 0),
    reason: data.reason || "Physical Audit",
    notes: data.notes || "",
    referenceId: data.referenceId || null, // e.g. invoiceId
    createdBy: data.createdBy || "admin",
    createdAt: data.createdAt || new Date().toISOString()
  };
}
